<!-- Translated: yes -->
<template>
  <Modal class="modal-relative" @close="closeModal" :wide="false" width="500px">
    <div :class="{'dropdown-wrap-wrapper': true, 'disabled': loading, 'visible': !loading}" v-if="showDate">
      <div class="label">{{ $t('general.pick-date') }}</div>
      <Dropdown
        prefixicon="calendar"
        prefixicon-validated="calendar-white"
        ref="dateDropdown"
        tabindex="0"
        :options="[]"
        :validated="pickedStartDate"
        :label="'' + formatDate(pickedStartDate) + ''"
        @clicked="datepickerModal"
        :bold-label="false"
        @clicked-suffix="dateClear">
      </Dropdown>
    </div>

    <div class="box info" v-if="!loading && !showDate && isSeason" style="margin-top: 0;">
      <b><icon name="info" :scale="1.4" />{{ $t('skipass.pickup-seasoncard') }}</b>
      <p>{{ $t('skipass.pickup-seasoncard-instructions-1') }}</p>
      <br>
      <p><b style="display:inline;">{{ $t('general.obs') }}</b> {{ $t('skipass.pickup-seasoncard-instructions-2') }}</p>
    </div>

    <div class="box info" v-if="showDate" style="margin-top:1em;">
      <!-- <b><icon name="info" :scale="1.4" />{{ $t('skipass.existing-booking-title') }}</b> -->
      <p v-if="hasRefill">För laddade liftkort: välj <strong>första åkdag</strong>.</p>
      <p v-if="hasRefill && hasNonRefill">&nbsp;</p>
      <p v-if="hasNonRefill">För nya liftkort: välj den dag du vill <strong>hämta</strong> ditt liftkort.</p>
      <!-- <p v-if="hasRefill && hasNonRefill">&nbsp;</p>
      <p v-if="hasRefill && hasNonRefill">Om du behöver välja olika datum, färdigställ din bokning och skapa en ny.</p> -->
    </div>

    <div :class="'space center info-wrapper'" v-if="hasNonRefill">
      <div v-if="FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')">
        <h2 class="center">När ska liftkorten börja användas?<br></h2>

        <Checkbox label-position="after" label="" :sublabel=skiPassAccomodationAfterCheckinText :value="'delivery'" :valuebinder.sync="delivery_type" :size="24" :below="true" />

        <Checkbox label-position="after" label="" :sublabel=skiPassAccomodationBeforeCheckinText :value="'pickup'" :valuebinder.sync="delivery_type" :size="24" :below="true" />
      </div>

      <div v-if="FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')">
        <h2 class="center" v-html="SETTING('SettingSkipassMachineInfo').title + '<br />'"></h2>
        <p v-bind:key="index" v-for="(paragraph, index) in SETTING('SettingSkipassMachineInfo').paragraphs" v-html="paragraph"></p>
        <!-- <p>Vill du hellre få liftkorten tillsammans med din förbokade utrustning? Inga problem, välj inga liftkort här, utan gör det när du bokar utrustning i stället.</p> -->
      </div>
      
      <hr />
    </div>

    <div class="space center info-wrapper" v-if="FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines') && hasNonRefill">
      <h2 class="center">Var vill du hämta liftkorten?<br></h2>

      <Checkbox label-position="after" label="" sublabel="Byn" :value="'by'" :valuebinder.sync="site" :size="24" :below="true" />

      <Checkbox label-position="after" label="" sublabel="Berget" :value="'berg'" :valuebinder.sync="site" :size="24" :below="true" />
    </div>

    <div class="center">
      <button :class="(!validated ? 'disabled' : '')" @click="addToCart()">{{$store.state.isOnSite ? $t('general.pay-with-card') : $t('general.add-to-cart')}}</button>
    </div>

  </Modal>
</template>

<script>
import Modal from '@/components/components/Modal';
import SwitchButton from '@/components/components/SwitchButton';
import Checkbox from '@/components/components/Checkbox';

import Dropdown from '@/components/components/Dropdown';

import API from '@/classes/API';

import { mapMutations } from 'vuex';

import moment from 'moment';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    SwitchButton,
    Checkbox,
    Dropdown,
  },
  data() {
    return {
      site: '',
      insurance: null,
      markInsurance: false,
      pickupTime: null,
      phone: null,
      errors: {},
      touched: {},
      pickedStartDate: null,
      validStartDates: [],
      showDate: false,
      loading: true,
      delivery_type: 'delivery',
      hasAccomodation: false,
      isSeason: false,
    };
  },
  async mounted() {
    this.hasAccomodation = false;

    if ((this.$store.state.cart.accomodations.filter(a => a.confirmed).length
      || (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart))
      && !this.pickedStartDate && !this.$store.state.tempDate) {
      console.log(this.$store.state.cart.accomodations.filter(a => a.confirmed).length);
      if (this.$store.state.cart.accomodations.filter(a => a.confirmed).length) {
        const accomodations = this.$store.state.cart.accomodations.filter(a => a.confirmed);
        this.pickedStartDate = moment(accomodations[0].period.date_arrival).toDate();

        if (accomodations[0] && accomodations[0].site) {
          if (accomodations[0].site === 2007) {
            this.site = 'by';
          } else if (accomodations[0].site === 2006) {
            this.site = 'berg';
          }
        }

        this.hasAccomodation = true;
      } else {
        this.pickedStartDate = moment(this.$store.state.cart.addToOrder.dateStart).toDate();
      }
    }

    this.validStartDates = [];

    this.loading = true;
    const { nonSeasonCardsData } = await API.post('cart/skipass/cart-non-season-cards', this.$store.state.cart.skipasses);
    const nonSeasonCards = nonSeasonCardsData;
    this.loading = false;

    if (nonSeasonCards > 0) {
      this.isSeason = false;
    }

    if (this.SITE_CONFIG.site === 'kungsberget' && this.SITE_CONFIG.season.winter.premiere_weekend_start) {
      const date = moment(this.SITE_CONFIG.season.winter.premiere_weekend_start);

      if (nonSeasonCards === 0) {
        this.selectDates(date);
        this.loading = false;
      }

      this.loading = false;
    }

    const { data } = await API.post('skipass/get-valid-arrival-dates', this.$store.state.cart.skipasses);
    this.validStartDates = data;

    this.restrictDates();

    if (!this.pickedStartDate) {
      this.showDate = true;

      // Set date
      if (this.$store.state.tempDate) {
        this.pickedStartDate = this.$store.state.tempDate;
        this.$store.state.tempDate = null;
      } else if (this.$store.state.cart.addToOrder && this.$store.state.cart.dateStart) {
        this.pickedStartDate = this.$store.state.cart.addToOrder.dateStart;
      } else {
        const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
        const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

        if (confirmed.length) {
          const start = moment(confirmed[0].period.date_arrival);
          this.pickedStartDate = start.toDate();
          this.hasAccomodation = true;
          this.showDate = false;
        }
      }
    }

    if (['vallasen', 'ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(this.SITE_CONFIG.site) !== -1) {
      this.showDate = false;

      const start = moment(this.validStartDates[0]).toDate();
      const now = moment().toDate();

      if (now > start) {
        this.pickedStartDate = now;
      } else {
        this.pickedStartDate = start;
      }

      console.log('Setting date to ', this.pickedStartDate);
      // this.addToCart();
    }

    if (!this.hasAccomodation) {
      this.delivery_type = 'pickup';
    }

    if (this.SITE_CONFIG.site === 'kungsberget') {
      this.delivery_type = 'pickup';
    }

    if (this.showDate === false && this.hasAccomodation === false && this.isSeason === false) {
      this.addToCart();
    }

    this.loading = false;

    if (this.hasRefill) {
      this.showDate = true;
    }
  },
  computed: {
    validated() {
      let valid = true;

      if (!this.pickedStartDate) {
        valid = false;
      }

      if (this.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')) {
        const siteOkay = this.delivery_type === 'delivery' || this.site || this.hasOnlyRefill;
        if (!siteOkay && this.SITE_CONFIG.site === 'branas') {
          valid = false;
        }
      }

      return valid;
    },
    skiPassAccomodationAfterCheckinText() {
      return 'Efter incheckning i boendet. Liftkorten levereras med nycklarna.';
    },
    skiPassAccomodationBeforeCheckinText() {
      return 'Före incheckning i boendet. Liftkorten hämtas i skidhyran.';
    },
    localSkipasses() {
      return this.$store.state.cart.skipasses.filter(s => s.type !== 'SKIPASS-ACCO');
    },
    hasRefill() {
      return this.localSkipasses.filter(s => s.refill).length;
    },
    hasOnlyRefill() {
      return this.localSkipasses.filter(s => s.refill).length === this.localSkipasses.length;
    },
    hasNonRefill() {
      return this.localSkipasses.filter(s => !s.refill).length;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'confirmSkiPass',
      'saveCartLocking',
    ]),
    restrictDates() {
      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        const loopStart = moment(this.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate();
        const end = moment(this.$store.state.cart.addToOrder.dateEnd).toDate();

        let current = loopStart;

        const newArray = [];

        while (current < end) {
          const next = moment(current).add(1, 'days');
          if (this.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1
            && this.validStartDates.indexOf(next.format('YYYY-MM-DD')) !== -1) {
            newArray.push(next.format('YYYY-MM-DD'));
          }
          current = next.toDate();
        }

        this.validStartDates = newArray;
      }
    },
    addToCartAndPay() {
      this.addToCart(true);
    },
    async addToCart(pay) {
      if (!this.validated) {
        return false;
      }

      if (this.hasOnlyRefill) {
        this.delivery_type = 'pickup';
      }

      const o = {
        date: this.pickedStartDate,
        type: this.hasAccomodation ? this.delivery_type : 'pickup',
        site: this.site,
      };

      if (this.delivery_type === 'delivery') {
        const cartAccomodationObject = this.$store.state.cart.accomodations[0];

        const accObject = Object.assign({}, {
          pool_lid: cartAccomodationObject.poolLid,
          unit_lid: cartAccomodationObject.unitLid,
          name: cartAccomodationObject.name,
        });

        const deliveryTo = {
          pool_lid: accObject.pool_lid,
          unit_lid: accObject.unit_lid,
          name: accObject.name,
        };

        if (!this.$store.state.cart.deliveryTo.length) {
          o.deliveryTo = deliveryTo;
        }
      }

      this.confirmSkiPass(o);

      let url = '/locks/reserve';
      if (this.$store.state.lockingCode) {
        url = `${url}/${this.$store.state.lockingCode}`;
      }
      const { before_time, code } = await API.get(url); // eslint-disable-line

      this.saveCartLocking({
        code,
        beforeTime: before_time,
      });

      window.trackAddToCart({
        title: 'Liftkort',
        lines: this.$store.state.cart.skipasses.map(product => ({
          id: product.pool_lid,
          title: 'Liftkort',
          category: 'equipment',
          quantity: 1,
          price: product.price,
        })),
      });

      if (!this.$store.state.isOnSite) {
        if (pay) {
          this.$router.push({ path: '/varukorg?pay=1' });
        } else {
          this.$router.push({ path: '/varukorg?show-confirmation=1&ref=skipass' });
        }
      } else {
        this.closeAllModals();

        setTimeout(() => {
          this.openModal(['OnSitePayment']);
        }, 1);
      }

      return true;
    },
    selectDates(start) {
      this.pickedStartDate = start;
      this.$store.state.tempDate = this.pickedStartDate;

      console.log(this.pickedStartDate);
      console.log(this.$store.state.tempDate);
    },
    datepickerModal() {
      let info = this.$i18n.t('general.pick-extradition');
      let extra = '';
      if (this.SITE_CONFIG.site === 'branas') {
        extra = this.$i18n.t('general.pick-extradition-note-branas');
      } else if (this.SITE_CONFIG.site === 'kungsberget') {
        extra = this.$i18n.t('general.pick-extradition-note-kungsberget');
      }

      info = `${info}<br>${extra}`;

      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        pickedEndDate: null,
        onClose: this.selectDates,
        night: false,
        startDateOnly: true,
        terminology: this.$i18n.t('general.pick'),
        info,
      }]);
    },
    dateClear() {
      this.pickedStartDate = null;
      this.$store.state.tempDate = this.pickedStartDate;
    },
    formatDate() {
      if (this.pickedStartDate) {
        return moment(this.pickedStartDate).format('D MMMM YYYY');
      }
      return this.$i18n.t('general.pick-date');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.uppercase
  uppercase()

.dropdown-wrap-wrapper
  max-height 1px
  overflow: hidden;
  transition: all 0.5s
  &.visible
    max-height 999px
  &.disabled
    disabled()

.box
  border-radius 3px
  background-color #ffffff
  border solid 1px #c2dbe2
  margin-bottom 20px
  &.info
    border-radius 2px
    background-color rgba(199, 220, 183, 0.26)
    border solid 1px #d1e0c2
    padding 15px 27px
    margin-top: 30px
    &.extra-info
      background-color: #fff4d7
      border: 1px solid #ffe67d
    b
      font-size 11px
      font-weight bold
      color #1c1c1c
      display block
      margin-bottom 5px
      uppercase()
      .icon
        margin-right 3px
        position relative
        top -1px
    p
      font-size 14px
      font-weight 300
      line-height 1.3
      color #262626
      margin 0
    &.small
      padding 10px 8px
      p
        font-size 11px
        color #1c1c1c
  &.box-error
    border-color warning

label
  font-size: 11px

.dropdown-wrapper
  width 100%

.label
  uppercase()
  font-size 11px
  font-weight bold
  margin-bottom 5px
  text-align: left

.box.checkboxes
  padding 1rem 2rem 0.5rem 0.5rem;
  display flex
  flex-wrap: wrap;
  &.phone
    padding: 0px;
    border: solid 0px #c2dbe2;
  &.box-error
    input
      border-color warning !important
    input
      background-color: #fff;
      border: solid 1px light-blue;
  label
    width 100%
  & > div
    width 90px
    margin-right 20px
    text-align center
    border-right: 1px solid #c2dbe263;
    +max-mobile()
      margin-right: 2px;
      width: 80px;
    &.phone-number
      margin: 0px
      width: 100%
      text-align: left;
      margin-top: 10px
      border-right: 0px solid #c2dbe263;
      font-size: 11px

.info-wrapper
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background-color: rgba(236,245,248,.3);
  margin-left: -45px;
  width: calc(100% + 90px);
  padding-left: 25%;
  padding-right: 25%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  h2
    font-size 21px
    width: 100%

  div
    width 100%
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  hr
    width 100%
</style>



// WEBPACK FOOTER //
// SkiPassConfirm.vue?34eb6a68